import * as React from 'react';
import { useSelector } from 'react-redux';

import { NewbuildingBrochureContainer } from 'shared/containers/NewbuildingBrochure';

import { NewbuildingSpecifications as NewbuildingSpecificationsComponent } from '../../components/NewbuildingSpecifications';
import {
  getNewbuildingSpecifications,
  getNewbuildingDeveloper,
  getNewbuildingStatus,
  getNewbuildingAdvantages,
  getNewbuildingName,
} from '../../selectors/newObject';

export const NewbuildingSpecifications: React.FC = () => {
  const advantages = useSelector(getNewbuildingAdvantages);
  const name = useSelector(getNewbuildingName);
  const specifications = useSelector(getNewbuildingSpecifications);
  const status = useSelector(getNewbuildingStatus);
  const developer = useSelector(getNewbuildingDeveloper);

  if (!advantages || advantages.length === 0) {
    return null;
  }

  return (
    <NewbuildingSpecificationsComponent
      brochure={<NewbuildingBrochureContainer />}
      specifications={specifications}
      developer={developer}
      status={status}
      name={name}
    />
  );
};
